import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

import Header from '../components/common/header/header';
import Sidebar from '../components/common/sidebar/sidebar';

import Organization from '../components/Admin/Organization/OrganizationList';
import AddOrganization from '../components/Admin/Organization/AddOrganization';
import ProgramsList from '../components/Admin/Program/ProgramsList';
import CreateProgram from '../components/Admin/Program/CreateProgram';
import ProgramUsersListing from '../components/Admin/Program/ProgramUsersListing';
import ManageRole from '../components/Admin/Roles/manage-role';
import NotificationsList from '../components/Admin/Notifications/NotificationsList';
import CreateNotification from '../components/Admin/Notifications/CreateNotification';
import { CreateRole } from '../components/Admin/Roles/CreateRole';
import { useSelector } from 'react-redux';
import PatientsDetails from '../components/apps/Patient/patients-detail';
import ManageGroup from '../components/apps/Threashold/manage-group';
import CreateEmployee from '../components/Admin/Individuals/create-employee';
import CreateAdmin from '../components/Admin/Individuals/create-admin';
import CreateApiAccount from '../components/Admin/Individuals/create-api-account';
import CreatePatient from '../components/Admin/Individuals/create-patient';
import Employees from '../components/Admin/Individuals/employees';
import Admins from '../components/Admin/Individuals/admins';
import Patients from '../components/Admin/Individuals/patients';
import ApiAccounts from '../components/Admin/Individuals/api-accounts'
import ZoomCreate from '../components/Zoom/ZoomCreate';
import Dashboard from '../components/Admin/Dashboard/dashboard';
import UserProfile from '../components/Profile/user-profile';
import CreateSchedule from '../components/Admin/Schedule/CreateSchedule';
import ChangePassword from '../components/Profile/change-password';
import ThresholdPatientList from '../components/apps/Threashold/threshold-patient-list';
import ScheduleList from '../components/Admin/ScheduleCategory/category-list';
import AddSchedule from '../components/Admin/ScheduleCategory/add-category';
import ClinicLocationList from '../components/Admin/Clinic Location/List';
import AddClinicLocation from '../components/Admin/Clinic Location/Add';
import EncounterSearch from '../components/apps/Encounters/EncounterSearch'
import EncounterRedirect from '../components/apps/Encounters/EncounterRedirect'
import ResourcesHub from '../components/apps/ResourcesHub/ResourcesHub'
import AppointmentsList from '../components/apps/AppointmentRequests/AppointmentsList';
import UserNotificationsList from '../components/Admin/Notifications/UserNotificationsList';
import CalendarView from '../components/Admin/Schedule/CalendarView';
import ScheduleOverview from '../components/Admin/Schedule/ScheduleOverview';
import GroupList from '../components/Admin/Group/GroupList';
import AddGroup from '../components/Admin/Group/AddGroup';
import GroupUsersListing from '../components/Admin/Group/GroupUsersListing';
import ListOfPractitioner from '../components/apps/ManageProviderSchedule&Appointments/ListOfPractitioner';
import CreateQuestion from '../components/Admin/Questionnaire/CreateQuestion';
import QuestionsList from '../components/Admin/Questionnaire/QuestionsList';
import CreateQuestionnaire from '../components/Admin/Questionnaire/CreateQuestionnaire';
import QuestionnaireList from '../components/Admin/Questionnaire/QuestionnaireList';
import SurveysList from '../components/Admin/Surveys/SurveysList';
import CreateSurveys from '../components/Admin/Surveys/CreateSurveys';
import SurveysResultsList from '../components/Admin/Surveys/SurveysResultsList';
import CreateCategory from '../components/Admin/Questionnaire/CreateCategory';
import CategoryList from '../components/Admin/Questionnaire/CategoryList';
import ServiceRequestWrapper from '../components/apps/ServiceRequest/ServiceRequestWrapper';
import ViewServiceRequest from '../components/apps/ServiceRequest/ViewServiceRequest';
import ViewMedicationRequest from '../components/apps/MedicationRequest/ViewMedicationRequest';
import CreateMedicationRequest from '../components/apps/MedicationRequest/CreateMedicationRequest';
import QueueList from '../components/Admin/Queue/QueueList';
import SFTList from '../components/Admin/SFT/SFTList';
import EncounterDetail from '../components/apps/Patient/EncounterDetail';
import DocumentList from '../components/Admin/FillableDocuments/DocumentList';
import AddDocuments from '../components/Admin/FillableDocuments/AddDocuments';
import CreateCondition from '../components/apps/MedicalHistory.js/CreateCondition';
import CreateSurgeryScreening from '../components/apps/MedicalHistory.js/CreateSurgeryScreening';
import EditCondition from '../components/apps/MedicalHistory.js/EditConditions';
import EditSurgeryScreening from '../components/apps/MedicalHistory.js/EditSurgeryScreening';
import ZoomCreateVV from '../components/Zoom/ZoomCreateVV';
import CreateFamilyHistory from '../components/apps/MedicalHistory.js/CreateFamilyHistory';
import EditFamilyHistory from '../components/apps/MedicalHistory.js/EditFamilyHistory';
import CreateObservation from '../components/apps/MedicalHistory.js/CreateObservation';
import EditObservation from '../components/apps/MedicalHistory.js/EditObservation';
import { useGetOrgLicensedProducts } from '../hooks/ReactQueryHooks/useGetOrgLicensedProducts';
import PhoneCallCreate from '../components/Zoom/PhoneCallCreate';
import { useEffect, useState } from 'react';
import { getOrganization } from '../components/api/Organization';
import { failed } from '../components/common/Toastify';
import DocumentDashboard from '../components/Admin/DocumentDashboard/DocumentDashboard';
import UploadDocument from '../components/Admin/DocumentDashboard/UploadDocument';
import EditDocument from '../components/Admin/DocumentDashboard/EditDocument';
import { FullPageSpinner } from '../components/common/Spinner/FullPageSpinner';
import MFALanding from '../components/MFA/MFALanding';
import Queue from '../components/apps/Queue/Queue';
import EncounterReportWR from '../components/apps/Queue/EncounterReportWR';
import EditQuestionnaire from '../components/Admin/Questionnaire/EditQuestionnaire';
import TriageParentComponent from '../components/apps/Protocol/TriageParentComponent';
import EncounterReport from '../components/apps/Patient/EncounterReport';
import DeviceList from '../components/Admin/Devices/DeviceList';
import CreateDevice from '../components/Admin/Devices/CreateDevice';
import IDPList from '../components/Admin/IDP/IDPList';
import IDP from '../components/Admin/IDP/IDP';
import IDPUpdate from '../components/Admin/IDP/IDPUpdate';
import HCNList from '../components/Admin/HCN/list-hcn';
import HCNCreate from '../components/Admin/HCN/create-hcn';
import HCNEdit from '../components/Admin/HCN/edit-hcn';
import CTIDashboard from '../components/Admin/CTI/dashboard';
import TaskList from '../components/Admin/Tasks/TaskList';
import { EditOrganization } from '../components/Admin/Organization/EditOrganization';
import EditServiceLine from '../components/Admin/Organization/EditServiceLine';
import ReportDeliveries from '../components/Admin/ReportDeliveries/ReportDeliveries';
import EditReportDelivery from '../components/Admin/ReportDeliveries/EditReportDelivery';
import OpsDashboardQueue from '../components/Admin/OpsDashboard/OpsDashboardQueue';
import OpsDashboardEncounter from '../components/Admin/OpsDashboard/OpsDashboardEncounter';
import OpsDashboardMain from '../components/Admin/OpsDashboard/OpsDashboardMain';
import { OpsContextProvider } from '../ContextsAndProvider/OpsContext';

const App = () => {
    const { pathname } = useLocation();
    const isEncounterRoute = pathname === '/app/zoom-meeting-create' || 
                             pathname === '/app/zoom-meeting-create-vv' || 
                             pathname === '/app/interaction' ||
                             pathname === '/app/encounter-redirect' ||
                             pathname.startsWith('/app/encounter-details');
    return (
        <OpsContextProvider>
            <div className="outer-wrapper">
                <Header />
                <div className={`body-outer ${isEncounterRoute ? 'encounter-active' : ''}`}>
                    {!isEncounterRoute && <Sidebar />}
                    <div className={`body-wrapper ${isEncounterRoute ? 'full-width' : ''}`}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </OpsContextProvider>
    );
};

export const NoPermission = () => {
    const navigate = useNavigate()
    return navigate("/app/dashboard");
};

export const useProtectedRoutes = () => {

    const permissions = useSelector((state) => state?.auth?.user?.permissions);
    const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const admin = userRoles?.includes('Super-Admin');
    const practitioner = userRoles?.includes('Practitioner');
    const { isLoading, data: orgLicensedProducts } = useGetOrgLicensedProducts({ refetchInterval: 300000 })
    const isVirtualCareEnable = admin ? true : orgLicensedProducts?.virtualCare;
    const isRPMEnable = admin ? true : orgLicensedProducts?.RPM;
    const [isWaitingRoom, setIsWaitingRoom] = useState(null)
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname !== "/" && pathname !== "/login" && adminOrgs) {
            getOrganization(adminOrgs?.[0]?.id)
                .then((res) => {
                    setIsWaitingRoom(res?.data?.isWaitingRoom)
                })
                .catch((res) => {
                    if (pathname !== "/sft") {
                        failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
                    }
                });
        }
    }, [])

    const protectedRoutes = [
        {
            path: '/app',
            element: <App />,
            children: [
                //Admin's Routes goes here
                //orgs
                { path: "add-organization", element: admin ? <AddOrganization /> : <NoPermission /> },
                { path: "edit-organization", element: (admin || permissions?.includes("Manage Organization")) ? <EditOrganization /> : <NoPermission /> },
                { path: "manage-organization", element: permissions?.includes('Manage Organization') || admin ? <Organization /> : <NoPermission /> },
                //org's program
                { path: 'create-program', element: permissions?.includes('Manage Program') || admin ? <CreateProgram /> : <NoPermission /> },
                { path: "manage-program", element: permissions?.includes('Manage Program') || admin ? <ProgramsList /> : <NoPermission /> },
                { path: "program-patients-listing", element: (permissions?.includes('Manage Program')) || admin ? <ProgramUsersListing /> : <NoPermission /> },
                //org's Questionnaires
                { path: 'create-questions', element: permissions?.includes('Manage Questionnaire') || admin ? <CreateQuestion /> : <NoPermission /> },
                { path: 'manage-questions', element: permissions?.includes('Manage Questionnaire') || admin ? <QuestionsList /> : <NoPermission /> },
                { path: "create-questionnaire", element: permissions?.includes('Manage Questionnaire') || admin ? <CreateQuestionnaire /> : <NoPermission /> },
                { path: "edit-questionnaire", element: permissions?.includes('Manage Questionnaire') || admin ? <EditQuestionnaire /> : <NoPermission /> },
                { path: "manage-questionnaire", element: permissions?.includes('Manage Questionnaire') || admin ? <QuestionnaireList /> : <NoPermission /> },
                { path: "create-category", element: permissions?.includes('Manage Questionnaire') || admin ? <CreateCategory /> : <NoPermission /> },
                { path: "manage-category", element: permissions?.includes('Manage Questionnaire') || admin ? <CategoryList /> : <NoPermission /> },
                { path: "report-deliveries", element: permissions?.includes('Report Deliveries - Read') || admin ? <ReportDeliveries /> : <NoPermission />},   
                { path: "create-report-delivery", element: permissions?.includes('Report Deliveries - Edit') || admin ? <EditReportDelivery new={true} /> : <NoPermission />},   
                { path: "edit-report-delivery", element: permissions?.includes('Report Deliveries - Edit') || admin ? <EditReportDelivery /> : <NoPermission />},   

                //org's roles
                { path: "create-role", element:  admin ? <CreateRole /> : <NoPermission /> },
                { path: "manage-roles", element: permissions?.includes('Manage Roles') || admin ? <ManageRole /> : <NoPermission /> },
                //org's Individuals
                { path: "create-employee", element: permissions?.includes('practitioner-create') || admin ? <CreateEmployee /> : <NoPermission /> },
                { path: "create-admin", element:  admin ? <CreateAdmin /> : <NoPermission /> },
                { path: "create-api-account", element:  admin ? <CreateApiAccount /> : <NoPermission /> },
                { path: "create-patient", element: permissions?.includes('patient-create') || admin ? <CreatePatient /> : <NoPermission /> },
                { path: "create-device", element: admin ? <CreateDevice /> : <NoPermission /> },
                { path: "identities/super-admins", element: admin ? <Admins /> : <NoPermission /> },
                { path: "identities/api-accounts", element: admin ? <ApiAccounts /> : <NoPermission /> },
                { path: "identities/employees", element: permissions?.includes('practitioner-read') || permissions?.includes('practitioner-create') || admin ? <Employees /> : <NoPermission /> },
                { path: "identities/patients", element: permissions?.includes('patient-read') || permissions?.includes('patient-create') || admin ? <Patients /> : <NoPermission /> },
                { path: "identities/devices", element: admin ? <DeviceList /> : <NoPermission /> },
                { path: "service-request", element: true || admin ? <ServiceRequestWrapper /> : <NoPermission /> },
                { path: "view-service-request", element: true || admin ? <ViewServiceRequest /> : <NoPermission /> },
                { path: "medication-request", element: true || admin ? <CreateMedicationRequest /> : <NoPermission /> },
                { path: "view-medication-request", element: true || admin ? <ViewMedicationRequest /> : <NoPermission /> },
                { path: "create-condition", element: true || admin ? <CreateCondition /> : <NoPermission /> },
                { path: "surgeries-screening", element: true || admin ? <CreateSurgeryScreening /> : <NoPermission /> },
                { path: "create-familyHistory", element: true || admin ? <CreateFamilyHistory /> : <NoPermission /> },
                { path: "create-observation", element: true || admin ? <CreateObservation /> : <NoPermission /> },
                { path: "edit-condition", element: true || admin ? <EditCondition /> : <NoPermission /> },
                { path: "edit-surgeries-screening", element: true || admin ? <EditSurgeryScreening /> : <NoPermission /> },
                { path: "edit-familyHistory", element: true || admin ? <EditFamilyHistory /> : <NoPermission /> },
                { path: "edit-observation", element: true || admin ? <EditObservation /> : <NoPermission /> },
                //org's notifications
                { path: "CreateNotification", element: permissions?.includes('Manage Notifications') || admin ? <CreateNotification /> : <NoPermission /> },
                { path: "manage-notifications", element: permissions?.includes('Manage Notifications') || admin ? <NotificationsList /> : <NoPermission /> },
                //User's notifications
                { path: "user-notifications", element: <UserNotificationsList /> },
                { path: "zoom-meeting-create", element: <ZoomCreate /> },
                { path: "zoom-meeting-create-vv", element: <ZoomCreateVV /> },
                { path: "interaction", element: <PhoneCallCreate /> },
                //HCN Authority Section starts here - 2 June 2025 deprecated
                // { path: "hcn-list", element: admin ? <HcnList /> : <NoPermission /> },
                // { path: "add-hcn", element: admin ? <AddHcn /> : <NoPermission /> },
                //Schedule category for doctor available time slots
                { path: "manage-schedule-category", element: (permissions?.includes('Manage Schedule Category')) && isVirtualCareEnable || admin ? <ScheduleList /> : <NoPermission /> },
                { path: "add-schedule", element: (permissions?.includes('Manage Schedule Category')) && isVirtualCareEnable || admin ? <AddSchedule /> : <NoPermission /> },
                //Clinic location
                { path: "locations", element: (permissions?.includes('Manage Locations')) || admin ? <ClinicLocationList /> : <NoPermission /> },
                { path: "add-clinic-location", element: (permissions?.includes('Manage Locations')) || admin ? <AddClinicLocation /> : <NoPermission /> },
                //Org's Group
                { path: "manage-groups", element: (permissions?.includes('Manage Groups')) && (isVirtualCareEnable || isRPMEnable) || admin ? <GroupList /> : <NoPermission /> },
                { path: "add-group", element: (permissions?.includes('Manage Groups')) || admin ? <AddGroup /> : <NoPermission /> },
                { path: "group-patients-listing", element: (permissions?.includes('Manage Groups')) || admin ? <GroupUsersListing /> : <NoPermission /> },
                // fillable Documents
                { path: "documents", element: isLoading ? <FullPageSpinner /> : ((permissions?.includes('Manage Documents')) || admin && isVirtualCareEnable) ? <DocumentList /> : <Navigate to="/app/dashboard" /> },
                { path: "add-documents", element: isLoading ? <FullPageSpinner /> : ((permissions?.includes('Manage Documents')) || admin && isVirtualCareEnable) ? <AddDocuments /> : <Navigate to="/app/dashboard" /> },

                //App's Routes goes here
                //pract's assigned patients
                { path: "patients-details", element: admin || practitioner ? <PatientsDetails /> : <NoPermission /> },
                { path: "encounter-details", element: admin || practitioner ? <EncounterReport /> : <NoPermission /> },
                { path: "encounter-report", element: admin || practitioner ? <EncounterReportWR /> : <NoPermission /> },
                //pract's threshold-groups for patients
                { path: "threshold-groups", element: permissions?.includes('Manage Threshold Groups') || admin || practitioner ? <ManageGroup /> : <NoPermission /> },
                { path: "threshold-patient-list", element: permissions?.includes('Manage Threshold Groups') || admin || practitioner ? <ThresholdPatientList /> : <NoPermission /> },
                //Dashboard
                { path: "dashboard", element: (permissions?.includes('Manage Individuals') && permissions?.includes('Manage Organization')) || admin || practitioner ? <Dashboard /> : <NoPermission /> },
                //change password
                { path: "change-password", element: <ChangePassword /> },
                { path: "user-profile", element: <UserProfile /> },
                //Manage pract's Schedule and appointment manage
                { path: "providers-schedule-appointments", element: permissions?.includes("Manage Provider Schedule & Appointments") && isVirtualCareEnable || admin  ? <ListOfPractitioner /> : <NoPermission /> },
                //pract's Schedule
                { path: "create-schedule", element: <CreateSchedule /> },
                { path: "edit-schedule", element: <CreateSchedule /> },
                { path: "schedule", element: !admin ? <CalendarView /> : <NoPermission /> },
                // Schedule Overview
                { path: "schedule-overview", element: permissions?.includes("Manage Provider Schedule & Appointments") || admin ? <ScheduleOverview /> : <NoPermission /> },
                // Appointment Requests
                { path: "appointment", element: (permissions?.includes('Appointment')) && isVirtualCareEnable || admin || practitioner ? <AppointmentsList /> : <NoPermission /> },
                // don't show to admin
                { path: "encounter-search", element: !admin ? <EncounterSearch /> : <NoPermission />},
                { path: "encounter-redirect", element: <EncounterRedirect /> },
                { path: "resources-hub", element: permissions?.includes('Access Resource Hub') || admin ?  <ResourcesHub/> : <NoPermission/>},
                // Protocol Assessment Route
                {path: "protocol-assessment", element: <TriageParentComponent />},
                // waiting room Section starts here
                // { path: "waiting-room", element: permissions?.includes("Waiting Room Enrollment") || permissions?.includes('Waiting Room Patients') ? <PatientListing canEnrollPatient={permissions?.includes("Waiting Room Enrollment")} canConnectWithPatient={permissions?.includes('Waiting Room Patients')} /> : <NoPermission /> },
                // { path: "join-waiting-room-meet", element: <JoinWaitingRoomMeet /> },
                // { path: "enroll-patient", element: permissions?.includes('Waiting Room Enrollment') ? <EnrollPatient /> : <NoPermission /> },
                //org's Surveys
                { path: "create-surveys", element: <CreateSurveys /> },
                { path: "manage-surveys", element: <SurveysList /> },
                { path: "manage-surveys-results", element: permissions?.includes('Satisfaction Survey Results') || admin ? <SurveysResultsList /> : <NoPermission /> },

                // Queue Service
                { path: "manage-queue", element: !admin ? isWaitingRoom ? (permissions?.includes('Manage Groups') || admin) ? <QueueList /> : <NoPermission /> : <NoPermission /> : <NoPermission /> },
                { path: "waiting-room", element: <Queue /> },
                // SFT Service
                { path: "manage-sft", element: (permissions?.includes('Manage SFT')) || admin ? <SFTList /> : <NoPermission /> },

                //Dashborad Routes
                { path: "document-dashboard", element: isLoading ? <FullPageSpinner /> : (isVirtualCareEnable && permissions?.includes("Access Document Dashboard") && practitioner) ? <DocumentDashboard /> : <Navigate to="/app/dashboard" /> },
                { path: "upload-document", element: isLoading ? <FullPageSpinner /> : (isVirtualCareEnable && permissions?.includes("Upload Documents") && permissions?.includes("Access Document Dashboard") && practitioner) ? <UploadDocument /> : <Navigate to="/app/dashboard" /> },
                { path: "edit-document", element: isLoading ? <FullPageSpinner /> : (isVirtualCareEnable && practitioner) ? <EditDocument /> : <Navigate to="/app/dashboard" /> },

                { path: "/app", element: <NoPermission /> },

                //MFA Settings
                { path: "mfa-settings", element: <MFALanding /> },
                { path: "idp", element: permissions?.includes('manage-identityProviders') || admin ? <IDPList /> : <NoPermission />},
                { path: "create-idp", element: permissions?.includes('manage-identityProviders') || admin ? <IDP /> : <NoPermission />},
                { path: "update-idp", element: permissions?.includes('manage-identityProviders') || admin ? <IDPUpdate /> : <NoPermission />},

                // HCN Authority Management
                { path: "list-hcn-authority", element: permissions?.includes('Manage Organization') || admin ? <HCNList /> : <NoPermission />},
                { path: "create-hcn-authority", element: permissions?.includes('Manage Organization') || admin ? <HCNCreate /> : <NoPermission />},
                { path: "edit-hcn-authority", element: permissions?.includes('Manage Organization') || admin ? <HCNEdit /> : <NoPermission />},

                // Task Management
                { path: "tasks", element: permissions?.includes('Write Task') || admin ? <TaskList /> : <NoPermission /> },

                // CTI Dashbaord
                { path: "telephony-dashboard", element: permissions?.includes("View Telephony Dashboard") || admin ? <CTIDashboard /> : <NoPermission /> },
                
                // Service Line
                { path: "edit-service-line", element: (admin || permissions?.includes("Manage Organization")) ? <EditServiceLine /> : <NoPermission />},

                // Ops Dashboard Routes (Super Admin Only)
                { path: "ops-dashboard-queue", element: admin ? <OpsDashboardQueue /> : <NoPermission /> },
                { path: "ops-dashboard-encounter", element: admin ? <OpsDashboardEncounter /> : <NoPermission /> },
                { path: "ops-dashboard-main", element: admin ? <OpsDashboardMain /> : <NoPermission /> }
            ]
        },
        { path: '/*', element: <Navigate to="/app/dashboard" /> },
    ];

    return { protectedRoutes };
} 
